import * as _ from "lodash";
import * as angular from "angular";
import { TeamColorDataProvider } from "../data-provider/team-color.dp";
import { getLicenseTypeFromPermissionId } from "../utils/user-permissions";

export class OrganisationInvite {
    public readonly requestIgnoreList = ["teamColorDataProvider"];
    private teamColorDataProvider: TeamColorDataProvider;

    public images: any;
    public initials?: string;

    public oid: any;
    public organisationinviteid: any;
    public organisationinviteemail: any;
    public organisationinvitesender: any;
    public organisationinvitestatusid: any;
    public organisationinvitetimestamp: any;
    public permission: object;
    public permissionid: any;
    public permissionname: any;
    public permissiontimestamp: any;
    public license_type: string;
    public permissiontype: any;
    public deliverystatus: any;
    public deliverytimestamp?: any;

    constructor(
        TeamColorDataProvider: TeamColorDataProvider,
        organisationInviteData?: object
    ) {
        this.teamColorDataProvider = TeamColorDataProvider;

        if (organisationInviteData) {
            this.setData(organisationInviteData);
        }
    }

    setData(data: any): void {
        angular.extend(this, data);
        this.updateLicenseType();
        this.getImage();
    }

    updateLicenseType(): void {
        if (!this.permission) return;

        this.license_type = getLicenseTypeFromPermissionId(
            this.permission["permissionid"]
        );
    }

    formatDeliveryStatus(): string {
        const statuses = {
            Sent: "Sent",
            Delivery: "Delivered",
            Bounce: "Bounced",
            Complaint: "Marked as spam",
        };

        if (this.deliverystatus) return statuses[this.deliverystatus] ?? "Sent";

        return "Sent";
    }

    getImage(): void {
        this.images = {};
        let color =
            this.teamColorDataProvider.teamColours[
                this.organisationinviteid %
                    this.teamColorDataProvider.teamColours.length
            ]; //gets a semi random color from colors array, that should always stay the same for same user
        this.initials =
            "https://eu.ui-avatars.com/api/?name=" +
            this.organisationinviteemail +
            "&background=" +
            color.substr(1) +
            "&length=1&color=fff&rounded=true&bold=true";
    }
}
